import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgHorizontalSlider = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.25 7.5a3.25 3.25 0 0 1 6.413-.75H19a.75.75 0 0 1 0 1.5h-8.337A3.251 3.251 0 0 1 4.25 7.5M7.5 5.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m2.337 10a3.251 3.251 0 0 1 6.326 0H19a.75.75 0 0 1 0 1.5h-2.837a3.251 3.251 0 0 1-6.326 0H5a.75.75 0 0 1 0-1.5zm3.163-1a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgHorizontalSlider;
